interface Props {
  rows?: number;
  label?: string;
}

// Vervangt de losse "Laden…"-tekst. Een skeleton houdt de hoogte van de pagina
// stabiel, zodat er niets verspringt zodra de data er is.
export function Skeleton({ rows = 4, label = 'Laden' }: Props) {
  return (
    <div className="skeleton-rows" aria-busy="true" aria-live="polite" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <span key={i} className="skeleton-row" />
      ))}
    </div>
  );
}
